module.exports = __webpack_public_path__ + "static/images/buy-img.b6a5b30.png";